export const skills = [
  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Python",
  "Django",
  "Git",
  "GitHub",
  "REST API",
  "MySQL",
  "MongoDB",
  "PostgreSQL",
  "Bootstrap",
];
